{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Cancelar",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integraciones",
    "DESCRIPTION": "El Centro de Contacto se integra con múltiples herramientas y servicios para mejorar la eficiencia de tu equipo. Explora la lista de abajo para configurar tus aplicaciones favoritas.",
    "LEARN_MORE": "Más información acerca de integraciones",
    "LOADING": "Obteniendo integraciones",
    "CAPTAIN": {
      "DISABLED": "El capitán no está habilitado en tu cuenta.",
      "CLICK_HERE_TO_CONFIGURE": "Haz clic aquí para configurar",
      "LOADING_CONSOLE": "Cargando consola del capitán...",
      "FAILED_TO_LOAD_CONSOLE": "No se pudo cargar la consola del capitán. Por favor, actualiza e inténtalo de nuevo."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Eventos suscritos",
      "LEARN_MORE": "Aprenda más sobre webhooks",
      "FORM": {
        "CANCEL": "Cancelar",
        "DESC": "Los eventos Webhook te proporcionan la información en tiempo real sobre lo que está sucediendo en tu cuenta. Por favor, introduce una URL válida para configurar un callback.",
        "SUBSCRIPTIONS": {
          "LABEL": "Eventos",
          "EVENTS": {
            "CONVERSATION_CREATED": "Conversación creada",
            "CONVERSATION_STATUS_CHANGED": "Estado de la conversación cambiado",
            "CONVERSATION_UPDATED": "Conversación actualizada",
            "MESSAGE_CREATED": "Mensaje creado",
            "MESSAGE_UPDATED": "Mensaje actualizado",
            "WEBWIDGET_TRIGGERED": "Widget de Live Chat abierto por el usuario",
            "CONTACT_CREATED": "Contacto creado",
            "CONTACT_UPDATED": "Contacto actualizado",
            "INBOX_CREATED": "Bandeja de entrada creada",
            "JARABOT_EVENT": "Eventos internos"
          }
        },
        "END_POINT": {
          "LABEL": "URL de Webhook",
          "PLACEHOLDER": "Ejemplo: {webhookExampleURL}",
          "ERROR": "Por favor, introduzca una URL válida"
        },
        "EDIT_SUBMIT": "Actualizar webhook",
        "ADD_SUBMIT": "Crear webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Configurar",
      "HEADER": "Configuración de Webhook",
      "HEADER_BTN_TXT": "Añadir nuevo webhook",
      "LOADING": "Obteniendo webhooks adjuntos",
      "SEARCH_404": "No hay elementos que coincidan con esta consulta",
      "SIDEBAR_TXT": "<p><b>Webhooks</b> </p> <p>Webhooks son callbacks HTTP que se pueden definir para cada cuenta. Son activados por eventos como la creación de mensajes. Puede crear más de un webhook para esta cuenta. <br /><br /> Para crear un webhook <b></b>, haga clic en el <b>Añadir un nuevo webhook</b> botón. También puede eliminar cualquier webhook existente haciendo clic en el botón Borrar.</p>",
      "LIST": {
        "404": "No hay webhooks configurados para esta cuenta.",
        "TITLE": "Administrar webhooks",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Final de Webhook",
          "ACTIONS": "Acciones"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Editar",
        "TITLE": "Editar Webhook",
        "API": {
          "SUCCESS_MESSAGE": "Configuración de webhook actualizada correctamente",
          "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
        }
      },
      "ADD": {
        "CANCEL": "Cancelar",
        "TITLE": "Añadir nuevo webhook",
        "API": {
          "SUCCESS_MESSAGE": "Configuración de webhook añadida correctamente",
          "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Eliminar",
        "API": {
          "SUCCESS_MESSAGE": "Webhook eliminado correctamente",
          "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
        },
        "CONFIRM": {
          "TITLE": "Confirmar eliminación",
          "MESSAGE": "¿Está seguro de eliminar el webhook? ({webhookURL})",
          "YES": "Sí, eliminar ",
          "NO": "No, mantenerlo"
        }
      },
      "DISABLED_BADGE": "Deshabilitado",
      "DISABLED_REASON": "Deshabilitado automáticamente tras {count} fallos consecutivos. Último error: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Habilitar",
        "API": {
          "SUCCESS_MESSAGE": "Webhook habilitado correctamente",
          "ERROR_MESSAGE": "No se pudo habilitar el webhook, inténtalo de nuevo más tarde"
        }
      }
    },
    "SLACK": {
      "DELETE": "Eliminar",
      "DELETE_CONFIRMATION": {
        "TITLE": "Eliminar la integración",
        "MESSAGE": "¿Está seguro que desea eliminar la integración? Si lo hace, perderá el acceso a las conversaciones en su espacio de trabajo Slack."
      },
      "HELP_TEXT": {
        "TITLE": "¿Cómo utilizar la Integración Slack?",
        "BODY": "Con esta integración, todas tus conversaciones entrantes serán sincronizadas con el canal ***{selectedChannelName}*** en tu espacio de trabajo en Slack. Puedes administrar todas tus conversaciones con los clientes directamente en tu canal y nunca perder un mensaje.\n\nEstas son las principales características de la integración:\n\n**Responda a conversaciones desde Slack:** Para responder a una conversación en el canal Slack ***{selectedChannelName}***, simplemente escriba el mensaje y envíalo como un hilo. Esto creará una respuesta que se enviará al cliente mediante el Centro de Contacto. ¡Es así de simple!\n\n**Crea notas privadas:** Si quieres crear una nota privada en lugar de una respuesta, comience su mensaje con ***`note:`***. Esto asegurará que tu mensaje se mantenga privado y no será visible al cliente.\n\n**Asociar un perfil de agente:** Si la persona que responde en Slack tiene un agente de perfil en el Centro de Contacto bajo el mismo correo electrónico, las respuestas serán asociadas con ese perfil de agente automáticamente. Esto quiere decir que puedes fácilmente estar al tanto de quién dijo qué y cuándo. Por el otro lado, cuando la persona que responde no tiene un perfil de agente, las respuestas aparecerán desde el perfil de bot al cliente.",
        "SELECTED": "seleccionado"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Seleccione un canal",
        "UPDATE": "Actualizar",
        "BUTTON_TEXT": "Conectar canal",
        "DESCRIPTION": "Su espacio de trabajo de Slack ahora esta enlazado con el Centro de Contacto. Sin embargo, la integración esta actualmente inactiva. Para activar la integración y conectar un canal, por favor haga clic en el siguiente boton.\n\n**Nota.** Si esta intentando conectar un canal privado, agregue nuestra aplicación al canal de Slack antes de proceder con este paso.",
        "ATTENTION_REQUIRED": "Atención requerida",
        "EXPIRED": "Su integración de Slack ha caducado. Para continuar recibiendo mensajes en Slack, por favor elimine la integración y vuelva a conectar su área de trabajo."
      },
      "UPDATE_ERROR": "Se presento un error actualizando la integración, por favor inténtelo nuevamente",
      "UPDATE_SUCCESS": "El canal está conectado correctamente",
      "FAILED_TO_FETCH_CHANNELS": "Hubo un error obteniendo los canales de Slack, por favor inténtalo de nuevo"
    },
    "OPEN_AI": {
      "AI_ASSIST": "Asistencia AI",
      "WITH_AI": " {option} con IA ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Responder sugerencia",
        "SUMMARIZE": "Resumir",
        "REPHRASE": "Mejorar escritura",
        "FIX_SPELLING_GRAMMAR": "Corregir ortografía y gramática",
        "SHORTEN": "Acortar",
        "EXPAND": "Expandir",
        "MAKE_FRIENDLY": "Cambiar tono de mensaje a amigable",
        "MAKE_FORMAL": "Usar tono formal",
        "SIMPLIFY": "Simplificar",
        "TRANSLATE": "Traducir",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Traducir al idioma mayoritario"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Contenido de borrador",
        "GENERATED_TITLE": "Contenido generado",
        "AI_WRITING": "AI está escribiendo",
        "BUTTONS": {
          "APPLY": "Usar esta sugerencia",
          "CANCEL": "Cancelar"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integrar con OpenAI",
        "DESC": "Trae las características avanzadas de IA a tu panel de control con los modelos GPT de OpenAI. Para empezar, introduce la clave API desde tu cuenta OpenAI.",
        "KEY_PLACEHOLDER": "Introduzca su clave API OpenAI",
        "BUTTONS": {
          "NEED_HELP": "¿Necesitas ayuda?",
          "DISMISS": "Descartar",
          "FINISH": "Finalizar configuración"
        },
        "DISMISS_MESSAGE": "Puedes configurar la integración OpenAI más tarde cuando quieras.",
        "SUCCESS_MESSAGE": "Configuración de integración OpenAI exitosa"
      },
      "TITLE": "Mejorar con IA",
      "SUMMARY_TITLE": "Resumen con IA",
      "REPLY_TITLE": "Responder sugerencia con IA",
      "SUBTITLE": "Se generará una respuesta mejorada usando IA basada en tu borrador actual.",
      "TONE": {
        "TITLE": "Tono",
        "OPTIONS": {
          "PROFESSIONAL": "Profesional",
          "FRIENDLY": "Amigable"
        }
      },
      "BUTTONS": {
        "GENERATE": "Generar",
        "GENERATING": "Generando...",
        "CANCEL": "Cancelar"
      },
      "GENERATE_ERROR": "Hubo un error al procesar el contenido, por favor verifique su clave API OpenAI e inténtelo de nuevo"
    },
    "DELETE": {
      "BUTTON_TEXT": "Eliminar",
      "API": {
        "SUCCESS_MESSAGE": "Integración eliminada correctamente"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Conectar"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Panel de aplicaciones",
      "HEADER_BTN_TXT": "Añadir una nueva aplicación",
      "SIDEBAR_TXT": "<p><b>Aplicaciones de panel</b></p><p>Aplicaciones de panel de control permiten a las organizaciones incrustar una aplicación dentro del panel de control para proporcionar el contexto para los agentes de atención al cliente. Esta característica le permite crear una aplicación de forma independiente e incrustarla dentro del panel de control para proporcionar información de usuario, sus pedidos, o su historial de pagos anterior.</p><p>Cuando incrustas tu aplicación en el panel de control, tu aplicación obtendrá el contexto de la conversación y el contacto como un evento de ventana. Implementa un oyente para el evento del mensaje en tu página para recibir el contexto.</p><p>Para añadir una nueva aplicación de panel, haga clic en el botón 'Añadir una nueva aplicación de panel'.</p>",
      "DESCRIPTION": "Las aplicaciones de panel permiten a las organizaciones incrustar una aplicación dentro del panel de control para proporcionar el contexto para los agentes de soporte al cliente. Esta función le permite crear una aplicación de forma independiente e incrustada para proporcionar información de usuario, sus pedidos o su historial de pagos anterior.",
      "LEARN_MORE": "Aprende más sobre el panel de aplicaciones",
      "LIST": {
        "404": "Todavía no hay aplicaciones configuradas en esta cuenta",
        "LOADING": "Obteniendo aplicaciones del tablero...",
        "TABLE_HEADER": {
          "NAME": "Nombre",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Editar aplicación",
        "DELETE_TOOLTIP": "Eliminar aplicación"
      },
      "FORM": {
        "TITLE_LABEL": "Nombre",
        "TITLE_PLACEHOLDER": "Ingrese un nombre para su aplicación de tablero",
        "TITLE_ERROR": "Se requiere un nombre para el panel de control",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Introduzca la URL del endpoint donde se aloja su aplicación",
        "URL_ERROR": "Se requiere una URL válida"
      },
      "CREATE": {
        "HEADER": "Añadir una nueva aplicación",
        "FORM_SUBMIT": "Enviar",
        "FORM_CANCEL": "Cancelar",
        "API_SUCCESS": "Panel de control configurado correctamente",
        "API_ERROR": "No pudimos crear una aplicación. Por favor, inténtalo de nuevo más tarde"
      },
      "UPDATE": {
        "HEADER": "Editar panel de aplicación",
        "FORM_SUBMIT": "Actualizar",
        "FORM_CANCEL": "Cancelar",
        "API_SUCCESS": "Panel de control actualizado correctamente",
        "API_ERROR": "No pudimos actualizar la aplicación. Por favor, inténtalo de nuevo más tarde"
      },
      "DELETE": {
        "CONFIRM_YES": "Sí, eliminarlo",
        "CONFIRM_NO": "No, mantenerlo",
        "TITLE": "Confirme eliminación",
        "MESSAGE": "¿Está seguro que desea eliminar la aplicación - {appName}?",
        "API_SUCCESS": "Panel de control eliminado con éxito",
        "API_ERROR": "No pudimos eliminar la aplicación. Por favor, inténtalo de nuevo más tarde"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Crear/Enlazar Problema Linear",
      "LOADING": "Cargando problemas lineales...",
      "LOADING_ERROR": "Hubo un error al recuperar los problemas lineales, por favor inténtalo de nuevo",
      "CREATE": "Crear",
      "LINK": {
        "SEARCH": "Buscar problemas",
        "SELECT": "Seleccionar problema",
        "TITLE": "Enlace",
        "EMPTY_LIST": "No se encontraron problemas lineales",
        "LOADING": "Cargando",
        "ERROR": "Hubo un error al recuperar los problemas lineales, por favor inténtalo de nuevo",
        "LINK_SUCCESS": "Incidencia enlazada correctamente",
        "LINK_ERROR": "Ocurrió un error al enlazar la incidencia. Inténtelo de nuevo",
        "LINK_TITLE": "Conversación (#{conversationId}) con {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Crear/enlazar incidencia con Linear",
        "DESCRIPTION": "Crear incidencias en Linear desde conversaciones, o enlazar existentes para un seguimiento fluido.",
        "FORM": {
          "TITLE": {
            "LABEL": "Título",
            "PLACEHOLDER": "Introducir título",
            "REQUIRED_ERROR": "El título es obligatorio"
          },
          "DESCRIPTION": {
            "LABEL": "Descripción",
            "PLACEHOLDER": "Introducir descripción"
          },
          "TEAM": {
            "LABEL": "Equipo",
            "PLACEHOLDER": "Seleccionar equipo",
            "SEARCH": "Buscar equipos",
            "REQUIRED_ERROR": "El equipo es requerido"
          },
          "ASSIGNEE": {
            "LABEL": "Cesionario",
            "PLACEHOLDER": "Seleccionar asignado",
            "SEARCH": "Buscar asignado"
          },
          "PRIORITY": {
            "LABEL": "Prioridad",
            "PLACEHOLDER": "Seleccionar prioridad",
            "SEARCH": "Buscar prioridad"
          },
          "LABEL": {
            "LABEL": "Etiqueta",
            "PLACEHOLDER": "Seleecionar etiqueta",
            "SEARCH": "Buscar etiqueta"
          },
          "STATUS": {
            "LABEL": "Estado",
            "PLACEHOLDER": "Seleccionar estado",
            "SEARCH": "Buscar estado"
          },
          "PROJECT": {
            "LABEL": "Proyecto",
            "PLACEHOLDER": "Seleccionar proyecto",
            "SEARCH": "Buscar proyecto"
          }
        },
        "CREATE": "Crear",
        "CANCEL": "Cancelar",
        "CREATE_SUCCESS": "Incidencia creada correctamente",
        "CREATE_ERROR": "Hubo un error creando la incidencia. Inténtalo de nuevo",
        "LOADING_TEAM_ERROR": "Hubo un error al coger los equipos. Inténtalo de nuevo",
        "LOADING_TEAM_ENTITIES_ERROR": "Hubo un error al coger las entidades del equipo. Inténtalo de nuevo"
      },
      "ISSUE": {
        "STATUS": "Estado",
        "PRIORITY": "Prioridad",
        "ASSIGNEE": "Cesionario",
        "LABELS": "Etiquetas",
        "CREATED_AT": "Creado en {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Desenlazar",
        "SUCCESS": "Problema desvinculado con éxito",
        "ERROR": "Se ha producido un error al desvincular el problema, inténtelo de nuevo"
      },
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Sí, eliminar",
        "CANCEL": "Cancelar"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Capitán",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "Enviar mensaje...",
      "LOADER": "Captain is thinking",
      "YOU": "Tú",
      "USE": "Use this",
      "RESET": "Reset",
      "SELECT_ASSISTANT": "Select Assistant",
      "EMPTY_MESSAGE": "Hubo un error al generar la respuesta. Por favor, inténtalo de nuevo."
    },
    "PAYWALL": {
      "TITLE": "Upgrade to use Captain AI",
      "AVAILABLE_ON": "Captain is not available on the free plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "UPGRADE_NOW": "Actualizar ahora",
      "CANCEL_ANYTIME": "Puede cambiar o cancelar su plan en cualquier momento"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI feature is only available in a paid plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "ASK_ADMIN": "Por favor, comuníquese con su administrador para la actualización."
    },
    "BANNER": {
      "RESPONSES": "You've used over 80% of your response limit. To continue using Captain AI, please upgrade.",
      "DOCUMENTS": "Document limit reached. Upgrade to continue using Captain AI."
    },
    "FORM": {
      "CANCEL": "Cancelar",
      "CREATE": "Crear",
      "EDIT": "Actualizar"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Sí, eliminar",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Assistant Name",
          "PLACEHOLDER": "Enter a name for the assistant",
          "ERROR": "Please provide a name for the assistant"
        },
        "DESCRIPTION": {
          "LABEL": "Assistant Description",
          "PLACEHOLDER": "Describe how and where this assistant will be used",
          "ERROR": "A description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter the name of the product this assistant is designed for",
          "ERROR": "The product name is required"
        },
        "FEATURES": {
          "TITLE": "Características",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions."
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "DESCRIPTION": "These FAQs are generated directly from the document."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select the assistant",
          "ERROR": "The assistant field is required"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Sí, eliminar",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "View Related Responses",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "Preguntas frecuentes",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Eliminar",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Sí, eliminar",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Todos"
      },
      "STATUS": {
        "TITLE": "Estado",
        "PENDING": "Pendientes",
        "APPROVED": "Approved",
        "ALL": "Todos"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select an assistant",
          "ERROR": "Please select an assistant."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Mark as approved",
        "EDIT_RESPONSE": "Edit FAQ",
        "DELETE_RESPONSE": "Delete FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Desconectar"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Sí, eliminar",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Bandeja de entrada",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
